(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.pkEditorialReady === 'true') return;
    root.dataset.pkEditorialReady = 'true';

    var autoNav = root.querySelector('[data-pk-auto-chapters]');
    if (autoNav) {
      var labels = (autoNav.dataset.labels || '').split('|').filter(Boolean);
      var headings = Array.from(root.querySelectorAll('.text-content-description h2')).slice(0, labels.length);
      var navInner = autoNav.querySelector('.pk-chapter-nav__inner');
      headings.forEach(function (heading, index) {
        var id = heading.id || ('pk-page-chapter-' + index);
        heading.id = id;
        var link = document.createElement('a');
        link.href = '#' + id;
        link.textContent = labels[index] || heading.textContent.trim();
        link.setAttribute('data-pk-chapter-link', '');
        navInner.appendChild(link);
      });
      var pageHeading = root.querySelector('h1');
      if (pageHeading && navInner.children.length) {
        pageHeading.insertAdjacentElement('afterend', autoNav);
        autoNav.hidden = false;
      }
    }

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var revealItems = root.querySelectorAll('[data-pk-reveal]');

    if (reduceMotion || !('IntersectionObserver' in window)) {
      revealItems.forEach(function (item) { item.classList.add('is-pk-visible'); });
    } else {
      root.classList.add('pk-editorial--motion-ready');
      var revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-pk-visible');
          revealObserver.unobserve(entry.target);
        });
      }, { threshold: 0.04, rootMargin: '14% 0px 14% 0px' });
      revealItems.forEach(function (item) { revealObserver.observe(item); });
    }

    var progress = root.querySelector('[data-pk-progress]');
    var parallaxItems = reduceMotion ? [] : Array.from(root.querySelectorAll('[data-pk-parallax]'));
    var ticking = false;

    function updateScrollEffects() {
      var rootRect = root.getBoundingClientRect();
      var scrollable = Math.max(root.offsetHeight - window.innerHeight, 1);
      var travelled = Math.min(Math.max(-rootRect.top, 0), scrollable);
      if (progress) progress.style.transform = 'scaleX(' + (travelled / scrollable) + ')';

      parallaxItems.forEach(function (item) {
        var rect = item.parentElement.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > window.innerHeight) return;
        var midpoint = rect.top + rect.height / 2;
        var distance = (midpoint - window.innerHeight / 2) / window.innerHeight;
        item.style.setProperty('--pk-parallax-y', (distance * -18).toFixed(2) + 'px');
      });
      ticking = false;
    }

    function requestScrollUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateScrollEffects);
    }

    window.addEventListener('scroll', requestScrollUpdate, { passive: true });
    window.addEventListener('resize', requestScrollUpdate, { passive: true });
    updateScrollEffects();

    var navLinks = Array.from(root.querySelectorAll('[data-pk-chapter-link]'));
    if (navLinks.length && 'IntersectionObserver' in window) {
      var sectionMap = new Map();
      navLinks.forEach(function (link) {
        var target = root.querySelector(link.getAttribute('href'));
        if (target) sectionMap.set(target, link);
      });
      var chapterObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          navLinks.forEach(function (link) { link.removeAttribute('aria-current'); });
          var active = sectionMap.get(entry.target);
          if (active) {
            active.setAttribute('aria-current', 'true');
            var navScroller = active.parentElement;
            if (navScroller && navScroller.scrollWidth > navScroller.clientWidth) {
              var targetLeft = active.offsetLeft - ((navScroller.clientWidth - active.offsetWidth) / 2);
              navScroller.scrollTo({ left: targetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
            }
          }
        });
      }, { rootMargin: '-15% 0px -72% 0px', threshold: 0 });
      sectionMap.forEach(function (_, section) { chapterObserver.observe(section); });
    }
  }

  function boot() {
    document.querySelectorAll('[data-pk-editorial]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
